module.exports = __webpack_public_path__ + "e21b886cb3c9f66dc4eb9bbb09149ece.svg";


//////////////////
// WEBPACK FOOTER
// ./src/viega-common/components/viega-header/img/burger-button-icon.svg
// module id = 9X5C
// module chunks = 5